import React, { useEffect, useState } from "react";
import { getCommonConfig, updateCommonConfig } from "@/services/commonconfig";

const FinancialsConfig: React.FC = () => {
  const [configData, setConfigData] = useState<any>({});
  const [savedConfig, setSavedConfig] = useState<any>(null);
  const [saving, setSaving] = useState(false);

  const [financialsPowerBiUrl, setFinancialsPowerBiUrl] = useState("");

  useEffect(() => {
    loadConfig();
  }, []);

  const loadConfig = async () => {
    const config = await getCommonConfig();

    setConfigData(config);
    setSavedConfig(config);

    setFinancialsPowerBiUrl(config?.PowerBIFinancialsUrl || "");
  };

  const hasChanges =
    savedConfig &&
    financialsPowerBiUrl !== (savedConfig.PowerBIFinancialsUrl || "");

  const handleSave = async () => {
    setSaving(true);

    try {
      const payload = {
        ...configData,
        PowerBIFinancialsUrl: financialsPowerBiUrl,
      };

      await updateCommonConfig(payload);

      setConfigData(payload);
      setSavedConfig(payload);
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    if (!savedConfig) return;

    setConfigData(savedConfig);
    setFinancialsPowerBiUrl(savedConfig.PowerBIFinancialsUrl || "");
  };

  return (
    <div className="border border-gray-200 rounded-md bg-[#fbfaf7] p-3 space-y-3">
      <div className="flex items-center gap-4 text-xs">
        <span className="w-44 text-gray-700">
          Financials Power BI URL
        </span>

        <input
          type="text"
          value={financialsPowerBiUrl}
          onChange={(e) => setFinancialsPowerBiUrl(e.target.value)}
          className="flex-1 border border-gray-300 rounded px-3 py-1 text-xs focus:outline-none focus:ring-1 focus:ring-[var(--color-brand)]"
          placeholder="Enter Power BI URL"
        />
      </div>

      <div className="flex justify-end gap-2 items-center pt-2">
        {hasChanges && (
          <div className="text-orange-600 border border-orange-300 bg-orange-50 px-2 py-0.5 rounded text-xs">
            Unsaved
          </div>
        )}

        <button
          className="bg-[#e7e5e0] px-3 py-1 text-xs"
          onClick={handleCancel}
          disabled={!hasChanges}
        >
          Cancel
        </button>

        <button
          className="bg-[var(--color-brand)] text-white px-3 py-1 text-xs"
          onClick={handleSave}
          disabled={!hasChanges || saving}
        >
          {saving ? "Saving..." : "Save"}
        </button>
      </div>
    </div>
  );
};

export default FinancialsConfig;